import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "page-card-search",
  template: "",
  standalone: false
})
export class PageCardSearchComponent {
  @Input()
  debounceTime: number = 250;

  @Output()
  startTyping: EventEmitter<void> = new EventEmitter();

  @Output()
  endTyping: EventEmitter<void> = new EventEmitter();

  @Output()
  search: EventEmitter<string> = new EventEmitter();
}
